module.exports = __webpack_public_path__ + "static/media/grabber-small-up.b60f2c59.svg";